import React, { useState, useMemo } from 'react';
import { FS3D } from '../FS3D';
import LB3D from '../LB3D';

const Table = ({
  fetchedData,
  GetInfo,
  navigate,
  profile,
  FS,
  BLK,
  length,
  width,
  thickness,
  LP,
  setIsOpen,
  closeSliderPanel,
  company
}) => {
  const [selectedMoldID, setSelectedMoldID] = useState('Show All');

  const filteredData = useMemo(() => {
    if (fetchedData?.itemIdsPerIteration) {
      if (selectedMoldID === 'Show All') return fetchedData.itemIdsPerIteration || [];
      return (
        fetchedData.itemIdsPerIteration.filter(
          iteration => iteration[0]?.partLot_MoldID_c === selectedMoldID
        ) || []
      );
    } else {
      if (selectedMoldID === 'Show All') return fetchedData || [];
      return (
        fetchedData?.filter(
          iteration => iteration[0]?.partLot_MoldID_c === selectedMoldID
        ) || []
      );
    }
  }, [selectedMoldID, fetchedData]);
  

  const transformedData = useMemo(() => {
    return filteredData.map(iteration =>
      iteration.reduce((acc, item) => {
        const existingItem = acc.find(
          i =>
            i.partLot_Depth_c === item.partLot_Depth_c &&
            i.partLot_Width_c === item.partLot_Width_c &&
            i.partLot_Length_c === item.partLot_Length_c
        );
        if (existingItem) {
          existingItem.count += 1;
        } else {
          acc.push({ ...item, count: 1 });
        }
        return acc;
      }, [])
    );
  }, [filteredData]);

  const moldIDs = useMemo(() => {
    let ids = [];
  
    if (fetchedData?.itemIdsPerIteration) {
      ids = fetchedData.itemIdsPerIteration.map(
        iteration => iteration[0]?.partLot_MoldID_c
      );
    } else if (Array.isArray(fetchedData)) {
      ids = fetchedData.map(iteration => iteration[0]?.PartLot_MoldID_c||iteration[0]?.partLot_MoldID_c);
    }
  
    return ['Show All', ...new Set(ids)];
  }, [fetchedData]);
  

  const filteredFS = useMemo(() => {
    if (selectedMoldID === 'Show All') return FS;
    return FS?.map(iteration =>
      iteration.filter(item => item.partLot_MoldID_c === selectedMoldID)
    ).filter(iteration => iteration.length > 0);
  }, [selectedMoldID, FS]);

  const filteredBLK = useMemo(() => {
    if (selectedMoldID === 'Show All') return BLK;
    return BLK?.map(iteration =>
      iteration.filter(item => item.partLot_MoldID_c === selectedMoldID)
    ).filter(iteration => iteration.length > 0);
  }, [selectedMoldID, BLK]);

  return (
    <>
      {filteredData.length > 0 && (
        <div className="dropdown-container mb-3 d-flex align-items-center justify-content-end">
          <label htmlFor="mold-select" className="me-2">Filter by MoldID:</label>
          <select
            id="mold-select"
            className="form-select"
            value={selectedMoldID}
            onChange={e => setSelectedMoldID(e.target.value)}
          >
            {moldIDs.map(moldID => (
              <option key={moldID} value={moldID}>{moldID}</option>
            ))}
          </select>
        </div>
      )}

      {/* Display error message if BLK is clicked */}
      

      {filteredData?.map((iteration, iterationIndex) => (
        <div
          key={`iteration-${iterationIndex}-${fetchedData.updatedAt || Math.random()}`}
          className="table-Container table-bg p-2 mt-3 m-1"
        >
          <div className="table-parent">
            <div className="d-flex justify-content-between align-items-center">
              <h4>{iteration[0]?.partLot_MoldID_c ||iteration[0]?.PartLot_MoldID_c }</h4>
              <button
                id="regen"
                className="submit-btn ro d-block m-2 rounded"
                onClick={GetInfo}
              >
                Manual placement
              </button>
            </div>
            <div className="table table-hover table-bordered my-3">
              <thead>
                <tr>
                  <th className="blue-table-header">Count</th>
                  <th className="blue-table-header">Element ID</th>
                  <th className="blue-table-header">Element Type</th>
                  <th className="blue-table-header">Thickness</th>
                  <th className="blue-table-header">Width</th>
                  <th className="blue-table-header">Length</th>
                </tr>
              </thead>
              <tbody>
  {transformedData[iterationIndex]?.map((item, index) => (
    <tr
      key={index}
      onClick={(event) => {
        event.stopPropagation(); // Prevent event bubbling
        
        if (item?.partLot_BuildingType_c !== 'BLK') {
        
          closeSliderPanel(); // Ensure the slider panel is closed before navigating
          navigate(`/form/Reinforcement/${item.partLot_LotNum}/${company}`);
        } else {
          
          closeSliderPanel(); // Explicitly close the panel if BLK is clicked
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      <td>{item.count}</td>
      <td>{item.partLot_LotNum}</td>
      <td>{item.partLot_BuildingType_c}</td>
      <td>{parseInt(item.partLot_Depth_c)}</td>
      <td>{parseInt(item.partLot_Width_c)}</td>
      <td>{parseInt(item.partLot_Length_c)}</td>
    </tr>
  ))}
</tbody>

            </div>
          </div>
          {profile === 'FS' ? (
            <FS3D
              index={iterationIndex + 1}
              FS={filteredFS[iterationIndex]?.map(x => ({
                ...x,
                length: parseInt(x['partLot_Length_c']),
                width: parseInt(x['partLot_Width_c']),
                thickness: parseInt(x['partLot_Depth_c']),
                itemType: x['partLot_BuildingType_c']
              }))}
              BLK={filteredBLK[iterationIndex]?.map(x => ({
                ...x,
                length: parseInt(x['partLot_Length_c']),
                width: parseInt(x['partLot_Width_c']),
                thickness: parseInt(x['partLot_Depth_c'])
              }))}
              totalLength={parseInt(length)}
              totalWidth={parseInt(width)}
              totalThickness={parseInt(thickness)}
              setIsOpen={setIsOpen}
            />
          ) : (
            <LB3D
              index={iterationIndex + 1}
              totalLength={parseInt(length)}
              totalWidth={parseInt(width)}
              totalThickness={parseInt(thickness)}
              LP={LP[iterationIndex]?.map(x => ({
                ...x,
                length: parseInt(x['partLot_Length_c']),
                width: parseInt(x['partLot_Width_c']),
                thickness: parseInt(x['partLot_Depth_c'])
              }))}
              BLK={filteredBLK[iterationIndex]?.map(x => ({
                ...x,
                length: parseInt(x['partLot_Length_c']),
                width: parseInt(x['partLot_Width_c']),
                thickness: parseInt(x['partLot_Depth_c'])
              }))}
              profile={profile}
              setIsOpen={setIsOpen}
            />
          )}
        </div>
      ))}
    </>
  );
};

export default Table;